module.exports = __webpack_public_path__ + "static/media/G_logo.5b645a53.svg";